import React from 'react';
import renderHTML from 'react-render-html';
import SummaryDetails from '../../ssm-components/summary-details/summary-details';
import SelectionOption from '../../ssm-components/selection-option/selection-option';
import TextWithTooltip from '../../../../components/text-with-tooltip/text-with-tooltip';
import DeviceHeader from '../../ssm-components/device-header/device-header';
import DeviceItem from '../../ssm-components/device-item/device-item';
import SSMFieldWrapper from '../ssm-field-wrapper/ssm-field-wrapper';
import TextFieldResizable from '../../../../components/form/text-field-resizable';
import FormSelectField from '../../../../components/form/select-field';
import { Desktop, Mobile } from '../../../../app-responsive';

import {
  SERVICE_TERM_PURCHASE_RADIO_BUTTON,
  SERVICE_TERM_RENTAL_RADIO_BUTTON,
  SERVICE_TERM_ADDITIONAL_INFO,
  PAYMENT_TYPE_MONTHLY,
  PAYMENT_TYPE_ONEOFF,
  PORT_TYPE_P_PHONE,
  PORT_TYPE_ANALOG,
  PORT_TYPE_MOBILE,
  SERVICE_TERM_DEVICE_TYPE_HANDSETS,
} from '../../../../app-constants';
import './service-term.css';

const ServiceTerm = (props) => {
  const {
    authorableContent: {
      title: serviceTermTitle,
      summary: serviceTermSummary,
      tooltip: serviceTermSummaryTooltip,
      purchaseSelectionOptionText,
      rentalSelectionOptionText,
      serviceText,
      quantityLabel,
      unitPriceLabel,
      itemsLabel,
      priceLabel,
      perMonthLabel,
      dateAndInfo,
      billing,
      estimatedOnceoffCharges,
      estimatedMonthlyCharges,
      purchaseMonthsText,
      rentalMonthsText,
      gstText,
    },
    products,
    onServiceTermRadioButtonsToggle,
    siteId,
    deviceQuantityOnChange,
    deviceQuantityOnBlur,
    deviceQuantityData,
    additionalInfoOnChange,
    additionalInfoOnBlur,
    formFieldsState,
    customerBillingAccountNumber,
    customerAccountNumbers,
    onAccountNumberSelectionOnBlur,
    migrationCount,
    serviceTermConnectionDateData,
    inDialUserTypeData,
  } = props;

  const getCallCenterItemsValuesCount = (callCenterElement) => {
    let matchingElementCount = 0;
    Object.entries(inDialUserTypeData).forEach(([key, value]) => {
      if (key.includes(siteId) && value === callCenterElement) {
        matchingElementCount += 1;
      }
    });
    return matchingElementCount;
  };

  const getIADCount = (analogDevicesCount) => {
    const iadCount = Math.floor(analogDevicesCount / 8);
    return iadCount > 0 ? iadCount + 1 : iadCount;
  };

  const getReadOnlyQuantity = (quantityType) => {
    let quantity;

    switch (quantityType) {
      case 'numberOfPhones':
        quantity = Math.round(migrationCount[`${siteId}-${PORT_TYPE_P_PHONE}`]);
        break;
      case 'numberOfAnalogue':
        quantity = Math.round(migrationCount[`${siteId}-${PORT_TYPE_ANALOG}`]);
        break;
      case 'numberOfMobiles':
        quantity = Math.round(migrationCount[`${siteId}-${PORT_TYPE_MOBILE}`]);
        break;
      case 'analogueTwo' :
        quantity = (migrationCount[`${siteId}-${PORT_TYPE_ANALOG}`] <= 2 && migrationCount[`${siteId}-${PORT_TYPE_ANALOG}`] > 0) ? 1 : 0;
        break;
      case 'analogueEight' :
        quantity = migrationCount[`${siteId}-${PORT_TYPE_ANALOG}`] > 2
          && migrationCount[`${siteId}-${PORT_TYPE_ANALOG}`] <= 8 ? 1 : getIADCount(migrationCount[`${siteId}-${PORT_TYPE_ANALOG}`]);
        break;
      case 'mireception' :
        quantity = getCallCenterItemsValuesCount('mireception');
        break;
      case 'callcenteragentstandard' :
        quantity = getCallCenterItemsValuesCount('callcenteragentstandard');
        break;
      case 'callcenteragentpremium' :
        quantity = getCallCenterItemsValuesCount('callcenteragentpremium');
        break;
      case 'callcentersupervisorstandard' :
        quantity = getCallCenterItemsValuesCount('callcentersupervisorstandard');
        break;
      case 'callcentersupervisorpremium' :
        quantity = getCallCenterItemsValuesCount('callcentersupervisorpremium');
        break;
      case 'mireceptioncallcenteragentstandard' :
        quantity = getCallCenterItemsValuesCount('mireceptioncallcenteragentstandard');
        break;
      default:
        break;
    }
    return quantity;
  };

  const getEditbaleQuantityValue = (deviceType, itemName) => {
    const deviceQuanityDataItem = deviceQuantityData.filter(
      quantityItem => quantityItem.id === `${deviceType}-${itemName}-${siteId}-quantity`)[0];
    if (deviceType === SERVICE_TERM_DEVICE_TYPE_HANDSETS && itemName === 'polycomVVX411') {
      if (deviceQuanityDataItem && deviceQuanityDataItem.quantity) {
        return deviceQuanityDataItem.quantity;
      } else if (migrationCount[`${siteId}-${PORT_TYPE_P_PHONE}`] !== undefined) {
        return migrationCount[`${siteId}-${PORT_TYPE_P_PHONE}`];
      }
      return 0;
    }
    return deviceQuanityDataItem ? deviceQuanityDataItem.quantity : 0;
  };

  const getTotalMOnthlyText = (serviceTermSelected, estimatedMonthlyTitle, purchaseText, rentalText, gst) =>
    (serviceTermSelected === SERVICE_TERM_PURCHASE_RADIO_BUTTON ?
      `${estimatedMonthlyTitle} ${purchaseText} ${gst}` : `${estimatedMonthlyTitle} ${rentalText} ${gst}`);

  // Map the quantities into the item.
  const serviceProducts = products.map(product => ({
    ...product,
    items: product.items.map(item => ({
      ...item,
      readOnlyQuantity: product.readOnlyQuantities[item.itemName],
      quantity: product.readOnlyQuantities[item.itemName] ?
        getReadOnlyQuantity(product.readOnlyQuantities[item.itemName]) : getEditbaleQuantityValue(product.deviceType, item.itemName),
    })),
  }));

  const billingAccountNumberOptions = customerAccountNumbers.map(accountNumber => (
    {
      id: accountNumber,
      value: accountNumber,
    }
  ));

  const {
    formFields,
    additionalInfoHeading,
  } = dateAndInfo;

  const {
    title: estimatedOnceOffTitle,
    tooltip: estimatedOnceOffToolTip,
  } = estimatedOnceoffCharges;

  const {
    title: estimatedMonthlyTitle,
    tooltip: estimatedMonthlyToolTip,
  } = estimatedMonthlyCharges;

  const {
    title: billingTitle,
    accountNumberPreText: billingAccountNumberPreText,
    accountNumberPostText: billingAccountNumberPostText,
    accountNumberLabel: billingAccountNumberLabel,

  } = billing;

  const defaultBillingAccountNumber = customerAccountNumbers[0];
  const customerBIllingAccountInformationText = `${billingAccountNumberPreText} ${defaultBillingAccountNumber}. ${billingAccountNumberPostText}`;

  const fieldWrapperConfiguration = {
    authorableContent: formFields,
    state: formFieldsState,
    onBlurFunction: additionalInfoOnBlur,
    onChangeFunction: additionalInfoOnChange,
    hasErrors: { SERVICE_TERM_ADDITIONAL_INFO: false },
  };

  const serviceTermOption = serviceTermConnectionDateData.find(item => item.siteId === siteId);
  const monthlyText = getTotalMOnthlyText(serviceTermOption.purchaseRentalSelectedOption,
    estimatedMonthlyTitle, purchaseMonthsText, rentalMonthsText, gstText);
  const servicesTermRadioButtonsOptions = [{
    radioButtonId: SERVICE_TERM_PURCHASE_RADIO_BUTTON,
    radioButtonLabel: purchaseSelectionOptionText,
    radioButtonDesc: null,
    radioButtonChecked: serviceTermOption && serviceTermOption.purchaseRentalSelectedOption === SERVICE_TERM_PURCHASE_RADIO_BUTTON,
    onRadioButtonCallBackActionWithToggle: onServiceTermRadioButtonsToggle,
  },
  {
    radioButtonId: SERVICE_TERM_RENTAL_RADIO_BUTTON,
    radioButtonLabel: rentalSelectionOptionText,
    radioButtonDesc: null,
    radioButtonChecked: serviceTermOption && serviceTermOption.purchaseRentalSelectedOption === SERVICE_TERM_RENTAL_RADIO_BUTTON,
    onRadioButtonCallBackActionWithToggle: onServiceTermRadioButtonsToggle,
  }];

  const devices = product => product.items.map((item) => {
    const deviceType = product.deviceType;
    // Default to 0 if quantitiesMin is not defined or the item does not exist in the object
    const quantityMin = product.quantitiesMin ? product.quantitiesMin[item.itemName] || 0 : 0;
    /* Use the minCost instead of the value if the value has not yet been set
      or if the value is less than the minCost */
    const useMinCost = !item.focused && item.quantity < quantityMin;

    const quantityValue = useMinCost ? quantityMin : item.quantity || 0;

    const deviceQuanityDataItem = deviceQuantityData.filter(
      quantityItem => quantityItem.id === `${deviceType}-${item.itemName}-${siteId}-quantity`)[0];

    const emptyDeviceQuantityData = deviceQuanityDataItem ? deviceQuanityDataItem.quantity : '';


    /* If we are using the min cost, update the value for pricing */
    if (useMinCost) {
      deviceQuantityData.filter(quantityItem => quantityItem.id === `${deviceType}-${item.itemName}-${siteId}-quantity`)[0].quantity = quantityValue;
    }

    const labels = { device: product.label, quantity: quantityLabel, unit: unitPriceLabel, price: priceLabel, toolTip: product.summary };

    return (
      <DeviceItem
        key={`${deviceType}-${item.itemName}-${siteId}`}
        deviceKey={`${deviceType}-${item.itemName}-${siteId}`}
        deviceName={item.title}
        readOnlyQuantity={item.readOnlyQuantity}
        linkText={item.linkText}
        linkURL={item.linkURL}
        deviceToolTipText={item.tooltip}
        deviceToolTipImagePath={item.tooltipImg}
        unitPricePurchaseValue={item.purchasePrice}
        unitPriceRentalValue={item.rentalPrice}
        unitPriceSuffixText={perMonthLabel}
        paymentType={product.paymentType}
        serviceTermSelectedOption={serviceTermOption.purchaseRentalSelectedOption}
        quantityValue={quantityValue}
        quantityInputOnChange={deviceQuantityOnChange}
        quantityInputOnBlur={deviceQuantityOnBlur}
        quantityMin={quantityMin}
        labels={labels}
        emptyDeviceQuantityData={emptyDeviceQuantityData}
      />
    );
  });

  // Multiply each items price by its quantity or '0' if quantity is not defined,
  // Then add all the prices together working in cents so we don't get decimal accuracy issues

  const totalCost = ((services, paymentType) => services.map(service => service.items.map(product => product[paymentType] *
    (parseInt(product.quantity, 10) || 0)))
    .flat().reduce((a, b) => ((parseFloat(a, 10) * 100) + (parseFloat(b, 10) * 100)) / 100));

  const oneOffTotal = (services => totalCost(services.filter(service => service.paymentType === PAYMENT_TYPE_ONEOFF ||
    (serviceTermOption.purchaseRentalSelectedOption === SERVICE_TERM_PURCHASE_RADIO_BUTTON
       && service.paymentType !== PAYMENT_TYPE_MONTHLY)), 'purchasePrice'));

  const monthlyTotal = (services => totalCost(services.filter(service => service.paymentType === PAYMENT_TYPE_MONTHLY ||
  (serviceTermOption.purchaseRentalSelectedOption !== SERVICE_TERM_PURCHASE_RADIO_BUTTON
     && service.paymentType !== PAYMENT_TYPE_ONEOFF)), 'rentalPrice'));

  return (
    <div className="service-section">
      <div className="row">
        <div className="service-section-header col-12 pl-sm-0">
          <h2 id="service-section-heading" className="service-section-heading">{serviceTermTitle}</h2>
          <div id="service-section-description" className="service-section-description">
            <div>{serviceTermSummary}
              <TextWithTooltip
                text={<i className="td-icon icon-help" />}
                textClassName="help-icon-container"
                id="service-section-description-tooltip"
                toolTipText={serviceTermSummaryTooltip}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="service-selection-options">
        <SelectionOption
          iconType="radioButton"
          radioButtonOptions={servicesTermRadioButtonsOptions}
        />
      </div>
      <div className="row">
        <div className="col-12 pl-sm-0">
          <span className="service-term-description">{renderHTML(serviceText)}</span>
        </div>
      </div>
      <DeviceHeader
        deviceNameHeadingText={itemsLabel}
        quantityHeadingText={quantityLabel}
        unitPriceHeadingText={unitPriceLabel}
        priceNameHeadingText={priceLabel}
      />

      {serviceProducts.map(product =>
        (<div key={`${product.deviceType}-device-${siteId}`} >
          <div className={`devices ${product.deviceType}-devices`}>
            {devices(product)}
          </div>
        </div>
        ),
      )}

      <Desktop>
        <div className="row">
          <div className="col-md-6 estimated-once-off-cost estimated-cost-description">
            <div>
              {estimatedOnceOffTitle}
              <TextWithTooltip
                text={<i className="td-icon icon-help" />}
                textClassName="help-icon-container"
                id="estimated-once-off-cost-tooltip"
                toolTipText={estimatedOnceOffToolTip}
              />
            </div>
          </div>

          <div className="col-md-6 estimated-monthly-cost estimated-cost-description">
            <div>
              {monthlyText}
              <TextWithTooltip
                text={<i className="td-icon icon-help" />}
                textClassName="help-icon-container"
                id="estimated-monthly-cost-tooltip"
                toolTipText={estimatedMonthlyToolTip}
              />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-6 estimated-once-off-cost estimated-cost-price">
            <div>
              <div className="total-price-estimate"><sup>$</sup>
                {Number.isInteger(oneOffTotal(serviceProducts)) ? oneOffTotal(serviceProducts) :
                  oneOffTotal(serviceProducts).toFixed(2)}</div>
            </div>
          </div>

          <div className="col-md-6 estimated-monthly-cost estimated-cost-price">
            <div className="total-price-estimate"><sup>$</sup>
              {Number.isInteger(monthlyTotal(serviceProducts)) ? monthlyTotal(serviceProducts) :
                monthlyTotal(serviceProducts).toFixed(2)}<sub>/month</sub></div>
          </div>
        </div>
      </Desktop>
      <Mobile>
        <div className="row estimated-once-off-cost mobile-seperation">
          <div className="col-12 estimated-cost-description">
            {estimatedOnceOffTitle}
            <TextWithTooltip
              text={<i className="td-icon icon-help" />}
              textClassName="help-icon-container"
              id="estimated-once-off-cost-tooltip"
              toolTipText={estimatedOnceOffToolTip}
            />
          </div>
          <div className="col-12 estimated-cost-price">
            <div className="mobile-totals total-price-estimate"><sup>$</sup>
              {Number.isInteger(oneOffTotal(serviceProducts)) ? oneOffTotal(serviceProducts) :
                oneOffTotal(serviceProducts).toFixed(2)}</div>
          </div>
        </div>

        <div className="row estimated-monthly-cost">
          <div className="col-12  estimated-cost-description">
            <div>
              {monthlyText}
              <TextWithTooltip
                text={<i className="td-icon icon-help" />}
                textClassName="help-icon-container"
                id="estimated-monthly-cost-tooltip"
                toolTipText={estimatedMonthlyToolTip}
              />
            </div>
          </div>
          <div className="col-12 estimated-cost-price">
            <div className="mobile-totals total-price-estimate"><sup>$</sup>
              {Number.isInteger(monthlyTotal(serviceProducts)) ? monthlyTotal(serviceProducts) :
                monthlyTotal(serviceProducts).toFixed(2)}<sub>{perMonthLabel}</sub></div>
          </div>
        </div>
      </Mobile>

      <div className="billing-section">
        <SummaryDetails
          summaryTitle={billingTitle}
          summaryText={customerBIllingAccountInformationText}
        />
      </div>
      <div className="row">
        <div className="input-label col-md-2 pl-sm-0">
          {billingAccountNumberLabel}
        </div>
        <div className="col-md-3">
          <FormSelectField
            id="service-term-billing-accounts-list"
            label=""
            disabled={false}
            options={billingAccountNumberOptions}
            value={customerBillingAccountNumber}
            onBlur={onAccountNumberSelectionOnBlur}
            placeholder=""
            initialValuePresent
          />
        </div>
      </div>
      <div className="row additional-info-section">
        <div className="col pl-sm-0">
          <h2 id="summary-heading" className="summary-heading">{additionalInfoHeading}</h2>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12 pl-sm-0">
          <SSMFieldWrapper
            config={fieldWrapperConfiguration}
            EditField={TextFieldResizable}
            id={SERVICE_TERM_ADDITIONAL_INFO}
            customClass="block-spacer"
          />
        </div>
      </div>
    </div>
  );
};

export default ServiceTerm;
